var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4526 12.4428C39.0439 12.4472 39.4688 12.7508 39.7349 13.1376C39.9377 13.4324 40.0285 13.7838 39.9924 14.0957C39.9563 14.4077 39.8136 14.6839 39.4822 14.9076C39.482 14.9076 39.4823 14.9076 39.4822 14.9076C37.5018 16.2467 33.8065 18.9001 30.2167 21.2189C28.4217 22.3783 26.6536 23.4531 25.1546 24.2312C23.6561 25.0089 22.3822 25.4663 21.8042 25.4676C16.3084 25.4676 12.2115 23.4426 5.29232 24.7318V23.3115C5.29324 23.2469 5.28129 23.1827 5.25719 23.1227C5.23309 23.0627 5.1973 23.0081 5.15192 22.9621C5.10653 22.9161 5.05245 22.8795 4.99281 22.8546C4.93317 22.8296 4.86917 22.8168 4.80453 22.8168C4.73988 22.8168 4.67588 22.8296 4.61625 22.8546C4.55661 22.8795 4.50253 22.9161 4.45714 22.9621C4.41175 23.0081 4.37597 23.0627 4.35187 23.1227C4.32776 23.1827 4.31582 23.2469 4.31673 23.3115V26.8919H2.85335V13.3508H4.31673V16.9312C4.31582 16.9958 4.32776 17.06 4.35187 17.12C4.37597 17.1799 4.41175 17.2346 4.45714 17.2806C4.50253 17.3266 4.55661 17.3631 4.61625 17.3881C4.67588 17.413 4.73988 17.4259 4.80453 17.4259C4.86917 17.4259 4.93317 17.413 4.99281 17.3881C5.05245 17.3631 5.10653 17.3266 5.15192 17.2806C5.1973 17.2346 5.23309 17.1799 5.25719 17.12C5.28129 17.06 5.29324 16.9958 5.29232 16.9312V15.747C7.0595 15.0461 9.91861 14.3507 11.5166 14.3507C13.3615 14.3507 14.6216 14.685 15.8278 15.0339C17.034 15.3829 18.1986 15.7556 19.7262 15.7556C19.7311 15.7557 19.736 15.7557 19.7409 15.7556L25.0082 15.5946C25.0079 15.5946 25.0087 15.5946 25.0082 15.5946C25.7648 15.5736 26.365 16.1678 26.365 16.8191C26.365 17.4707 25.7732 18.0094 24.9735 18.0439L14.9592 18.4732C14.8946 18.4751 14.8311 18.4899 14.7723 18.5166C14.7135 18.5433 14.6605 18.5814 14.6166 18.6287C14.5726 18.676 14.5384 18.7315 14.5161 18.7921C14.4938 18.8528 14.4837 18.9172 14.4865 18.9817C14.4892 19.0462 14.5048 19.1096 14.5322 19.1681C14.5597 19.2265 14.5984 19.279 14.6463 19.3223C14.6942 19.3657 14.7502 19.3991 14.8111 19.4207C14.8719 19.4422 14.9365 19.4515 15.001 19.4479L25.0154 19.0186C25.9658 18.9776 26.8255 18.4297 27.1749 17.6212C27.1921 17.6152 27.209 17.6082 27.2254 17.6003L37.3854 12.7129C37.7871 12.5205 38.1431 12.4404 38.4526 12.4428Z",
    fill: "url(#paint0_radial_528_1424)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3509H1.87801V26.8921H0V13.3509Z",
    fill: "url(#paint1_radial_528_1424)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6634 4.21453C14.4244 4.21453 13.4097 5.22914 13.4097 6.46814C13.4097 7.70713 14.4244 8.72174 15.6634 8.72174C16.9023 8.72174 17.917 7.70713 17.917 6.46814C17.917 5.22914 16.9023 4.21453 15.6634 4.21453Z",
    fill: "url(#paint2_radial_528_1424)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7604 0.399963C19.5214 0.399963 18.5068 1.4146 18.5068 2.6536C18.5068 3.88904 19.5214 4.90232 20.7604 4.90232C21.9959 4.90232 23.0092 3.88904 23.0092 2.6536C23.0092 1.4146 21.9959 0.399963 20.7604 0.399963Z",
    fill: "url(#paint3_radial_528_1424)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7113 4.21453C24.4723 4.21453 23.4577 5.22914 23.4577 6.46814C23.4577 7.70713 24.4723 8.72174 25.7113 8.72174C26.9503 8.72174 27.9649 7.70713 27.9649 6.46814C27.9649 5.22914 26.9503 4.21453 25.7113 4.21453Z",
    fill: "url(#paint4_radial_528_1424)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7604 8.27298C19.5214 8.27298 18.5068 9.28759 18.5068 10.5266C18.5068 11.7656 19.5214 12.7802 20.7604 12.7802C21.9959 12.7802 23.0092 11.7656 23.0092 10.5266C23.0092 9.28759 21.9959 8.27298 20.7604 8.27298Z",
    fill: "url(#paint5_radial_528_1424)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_528_1424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 13.3222) rotate(90) scale(43.9356 66.3377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1261BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1261BC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialTool);
export default __webpack_public_path__ + "static/media/financial_tool.fe6b52f3e629e37e2bd58919336d07dd.svg";
export { ForwardRef as ReactComponent };